export const MUSIC_TRACKS = {
    menu: [
        "cosmic-pond-of-arcane-waterfowl-135465.mp3",
        "fantasy-craft-loop-431346.mp3",
        "game-setting-fantasy-142092.mp3",
        "shadows-beneath-the-roots-fantasy-elvish-song-rpg-448106.mp3",
        "the-minstrels-return-loopable-fantasy-medieval-rpg-music-447849.mp3",
        "we-rise-again-fantasy-elvish-song-rpg-448107.mp3"
    ],
    battle: [
        "a-herox27s-return-229835.mp3",
        "battle-hymn-206855.mp3",
        "battle-woods-325160.mp3",
        "crimson-horizon-epic-fantasy-background-music-for-rpgs-409985.mp3",
        "epic-battle-song-182915.mp3",
        "kingdom-come-draconis-battle-of-the-dragons-diferent-variant-8372.mp3"
    ]
};
